const CMSFileNames = {
  prod: {
    onmoComplaintUrl: `Onmo_Complaints_Publication_Report_53c2ed37f6.pdf`,
    transactionDisputeUrl: `Transaction_Dispute_Form_29982d15bb.pdf`,
    fraudentForm: `Fraud_Application_Claim_Form_683dbcd16d.pdf`,
    faviconUrl: `Favicon1_2c46cceeb7.ico?v=2`,
    logoDarkUrl: `Logo_dark_026874f55e.png`,
    logoLightUrl: `Logo2x_d9d4344ce1.png`,
    onmoWhite: `logo_white_temp_2_d0b2946e29.svg`,
    metaUrl: `ONMO_d27c870b24_c75d5d18c2_7f48b58ff4.svg`,
    thirdPartyForm: `Onmo_Third_Party_Mandate_Form_851b9d2007.pdf`,
  },
  staging: {
    onmoComplaintUrl: `Onmo_Complaints_Publication_Report_8493c53776.pdf`,
    transactionDisputeUrl: `Transaction_Dispute_Form_fa321b70e5.pdf`,
    fraudentForm: `Fraudulent_Application_Claim_Form_6891ba1d39.pdf`,
    faviconUrl: `Favicon1_330d033aef.ico?v=2`,
    logoDarkUrl: `Logo_dark_5c7e3159ec.png`,
    logoLightUrl: `Logo_1_07a3adb2d7.png`,
    onmoWhite: `logo_white_temp_2_d8c91ef5ad.svg`,
    metaUrl: `ONMO_d27c870b24_c75d5d18c2.svg`,
    thirdPartyForm: `Onmo_Third_Party_Mandate_Form_ca0f858610.pdf`,
  },
};

const baseUrls = {
  prod: "https://d2f2p28idjlxwt.cloudfront.net/",
  staging: "https://d33eyb9ff1qnw3.cloudfront.net/",
};

const isProdEnv = () => process.env.NEXT_PUBLIC_STAGE === "prod";

const getUrlFromCMS = type => {
  const env = isProdEnv() ? "prod" : "staging";
  return baseUrls[env] + (CMSFileNames[env][type] || "");
};

export const CMSUrls = {
  onmoComplaintUrl: getUrlFromCMS("onmoComplaintUrl"),
  transactionDisputeUrl: getUrlFromCMS("transactionDisputeUrl"),
  fraudentForm: getUrlFromCMS("fraudentForm"),
  faviconUrl: getUrlFromCMS("faviconUrl"),
  logoDarkUrl: getUrlFromCMS("logoDarkUrl"),
  logoLightUrl: getUrlFromCMS("logoLightUrl"),
  onmoWhite: getUrlFromCMS("onmoWhite"),
  metaUrl: getUrlFromCMS("metaUrl"),
  thirdPartyForm: getUrlFromCMS("thirdPartyForm"),
};
